<template>
  <div id="Web_Nav" :class="navType">
    <div class="history-back" v-show="historyBack" @click="goBack">
      <img
        src="../../assets/icon/image_nav_back_arrow@3x.png"
        class="back-img"
      />
    </div>
    <div class="account" v-show="accountShow" @click="historyShow" disabled>
      <input type="text" class="hidden-input" v-if="!haveUserName" />
      <div class="back-inner">
        <a class="">
          <img :src="userImg" class="user-img" v-show="userImgShow" />
          <img
            src="../../assets/icon/image_instagram_placeholder@3x.png"
            v-show="!userImgShow"
            class="userImg"
          />
        </a>
      </div>
      <img
        src="../../assets/icon/image_nav_account_arrow@3x(1).png"
        class="down-img"
      />
    </div>
    <div class="title">
      <h1>{{ this.titleName }}</h1>
    </div>
    <div class="userCoins" v-show="coinShow">
      <img src="../../assets/icon/image_gx_coins@3x.png" alt="" />
      <span>{{ userCoins }}</span>
    </div>
    <div class="collect" v-show="collectShow" @click="addHome">
      <!-- <img src="../../assets/icon/image_nav_collect@3x.png" alt=""> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleName: String,
    navType: String,
    userCoins: String,
    schemeUrl: String,
    userImg: String,
    collectShow: Boolean,
    coinShow: Boolean,
    ImgShow: Boolean,
    accountShow: Boolean
  },
  data() {
    return {};
  },
  computed: {
    haveUserName() {
      if (this.$route.params.userName == "&") {
        return false;
      } else {
        return true;
      }
    },
    getzType() {
      if (this.navType == "getZ") {
        return true;
      }
    },
    getxType() {
      if (this.navType == "getX") {
        return true;
      }
    },
    // coinShow(){
    //   return this.$store.state.coinShow
    // },
    historyBack() {
      return this.$store.state.historyBackShow;
    },
    userImgShow() {
      if (this.$route.params.userName == "&") {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$store.commit("updateAllPostCate", {
        allPostCate: "All"
      });
    },
    historyShow() {
      if (this.$route.params.userName == "&") {
        this.$store.commit("updateLoginShow", {
          web_login_show: true
        });
      } else {
        this.$store.commit("updateAccountHistoryShow", {
          web_account_history_show: true
        });
        this.$store.commit("updateAnonterCountShow", {
          web_another_account_show: true
        });
        if (this.getUserslocalStorage() != null) {
          var arr = this.getUserslocalStorage();
          if (arr.length == 0) {
          } else {
            this.$store.commit("updateHistoryData", {
              web_history_data: this.getUserslocalStorage()
            });
          }
        }

        if (
          localStorage.getItem("usersData") &&
          JSON.parse(localStorage.getItem("usersData")).length > 0
        ) {
          this.$store.commit("updateEditButtonShow", {
            web_edit_button_show: true
          });
        } else {
          this.$store.commit("updateEditButtonShow", {
            web_edit_button_show: false
          });
        }
      }
    },
    addHome() {
      this.$store.commit("updateAddHomeShow", {
        addHome: true
      });
      ga("send", {
        hitType: "event",
        eventCategory: "add_home_click",
        eventAction: "click"
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#Web_Nav {
  .userCoins {
    position: absolute;
    right: 15px;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
    }
    span {
      display: block;
      font-size: 14px;
      color: #fff;
    }
  }
  .collect {
    position: absolute;
    right: 0px;
    top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 40px;
    img {
      display: block;
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
  }
  width: 100%;
  height: 40px;
  background: linear-gradient(to right, #1e2022, #414449);
  display: flex;
  order: 1;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  .history-back {
    position: absolute;
    left: 2px;
    top: 0;
    height: 40px;
    width: 44px;
    justify-content: center;
    align-items: center;
    display: flex;
    img {
      display: block;
      width: 22px;
      height: auto;
    }
    .black-back {
      width: 22px;
      height: auto;
    }
  }
  .account {
    position: absolute;
    left: 10px;
    top: 0;
    height: 40px;
    width: 50px;
    justify-content: center;
    align-items: center;
    display: flex;
    input {
      display: block;
      height: 40px;
      width: 50px;
      background: transparent;
      position: absolute;
      top: 0;
      left: 0;
      color: transparent;
      line-height: 0;
      font-size: 0px;
    }
    .back-inner {
      background: linear-gradient(
        to right,
        rgb(112, 73, 195),
        rgb(221, 51, 106),
        rgb(254, 183, 79)
      );
      width: 30px;
      height: 30px;
      border-radius: 50%;
      box-sizing: border-box;
      padding: 1px;
    }
    a {
      display: block;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      overflow: hidden;
      background: linear-gradient(to right, #1e2022, #414449);
      .userImg {
        display: block;
        width: 28px;
        height: 28px;
      }
    }
    .user-img {
      display: block;
      width: auto;
      height: 28px;
    }
    .down-img {
      display: block;
      width: 12px;
      height: auto;
      margin-left: 5px;
    }
  }
  .back-icon {
    position: absolute;
    left: 12px;
    top: 0;
    a {
      height: 40px;

      justify-content: center;
      align-items: center;
      display: flex;
      .back-img {
        display: block;
        width: 22px;
        height: auto;
        margin-right: 6px;
      }
      .user-img {
        display: block;
        width: 28px;
        height: 28px;
        border-radius: 50%;
      }
    }
  }
  .title {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    h1 {
      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 40px;
      font-weight: bold;
    }
    .user-img {
      display: block;
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebNavBar.vue?fe422132